import { useTranslation } from 'libs/i18n'
import { useDevice, usePagination } from 'shared/hooks'
import { Table2 } from 'shared/components'
import { Pagination } from 'shared/atoms'
import { getCardTableStyles } from 'styles/table'
import { User } from 'features/users/molecules/User/User'
import type { Option } from 'shared/components/ContextMenu/types'
import type { Select } from '@table-library/react-table-library/select'
import type { UsersRes } from 'features/users/types/users.types'
import { useColumns } from '../hooks/useColumns'

type TableSectionProps = {
	users: UsersRes
	select: Select
	menuOptions: Option[]
}

export const TableSection = ({ users, select, menuOptions }: TableSectionProps) => {
	const { t } = useTranslation()
	const { isMobileOrTablet } = useDevice()
	const { handlePagination } = usePagination()
	const columns = useColumns({ menuOptions })

	const results = users.data.results

	return (
		<>
			{isMobileOrTablet ? (
				<ul className="divide-y divide-border">
					{results.map((user) => (
						<User key={user.id} user={user} menuOptions={menuOptions} />
					))}
				</ul>
			) : (
				<Table2
					className="mb-0 px-0 py-0 lg:flex lg:min-h-0 lg:flex-1 lg:flex-col"
					columns={columns}
					data={{ nodes: results }}
					isLoading={false}
					select={select}
					customStyles={getCardTableStyles(columns, { clickableRows: false })}
				/>
			)}
			<div className="flex items-center justify-between gap-3 border-t border-border px-4 py-3 text-[11px] font-medium text-muted-foreground sm:px-5">
				<span>{t('{{ count }} users', { count: results.length })}</span>
				<Pagination prev={users.data.previous} next={users.data.next} onClick={handlePagination} />
			</div>
		</>
	)
}
